import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import {
  Link,
  AndrewBeharSignature
} from '../'
import Styles from './PlanScorecardCompanyLetter.css'


@CSSModules(Styles, {allowMultiple: true})
export default class PinterestCompanyLetter extends Component {
  static propTypes = {
    differentPage: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      differentPage: this.props.differentPage || false,
      companyName: 'Pinterest',
      companyPath: 'pinterest',
      letterDate: 'May 26, 2022',
      addresseeSurname: 'Mr. Silbermann',
      addressee: (
        <span>
          Ben Silbermann<br/>
          Chief Executive Officer
        </span>
      ),
      address: (
        <span>
          651 Brannan St<br/>
          San Francisco, CA<br/>
          94107
        </span>
      ),
      aspirationalGoal: 'its recent ban to prohibit all ads and posts that feature climate misinformation',
      ESGOptions: 'the Company’s employee retirement plan currently has only one ESG option available for employees who want to invest sustainably.',
      defaultPercent: 'Over 74% of assets',
    }
  }

  render() {
    //
    return (
      <blockquote styleName='company-letter-blockquote'>

        <p><b>May 26, 2022</b></p>

        <p><b>
        {this.state.addressee}
        <br/>
        {this.state.companyName}
        <br/>
        {this.state.address}
        </b></p>

        <p><b>Re: {this.state.companyName} employee retirement plan sustainability scorecard</b></p>

        <p>Dear {this.state.addresseeSurname},</p>

        <p>{this.state.companyName} is known to be a leader on climate change, highlighted by {this.state.aspirationalGoal}.</p>

        <p><b>However, your company retirement plan directly contradicts all of this hard work on your operations.</b></p>

        <p>I am writing to inform you about the recent release of <i>As You Sow’s</i> corporate retirement plan sustainability scorecard initiative and would like to extend an offer to meet and discuss our work. Below is a brief overview of the scorecard, where {this.state.companyName} is among the first companies rated. </p>

        <p>The corporate retirement plan sustainability scorecard initiative will empower the millions of U.S. employees holding trillions in retirement assets to invest their retirement savings sustainably. Many employees across the nation are unaware that their retirement plan investments are invested in climate change, prisons, weapons, and companies that score poorly on gender equality.</p>

        <p>We are using our <Link to={config.links.aysinvest} title='Invest Your Values - As You Sow' xstrong>expertise in mutual fund sustainability analysis</Link> and our extensive database of ESG-screened companies to rate corporations’ retirement plan investment options. Those investment options have been graded across seven major environmental and social issues, including deforestation, climate, and the prison industrial complex.</p>

        {
          this.state.differentPage ?
            (
              <p><b><Link to={config.routes.plans + '/' + this.state.companyPath} title={this.state.companyName + ' retirement plan sustainability scorecard'} xstrong>The scorecard results for {this.state.companyName}'s retirement plan</Link> directly contradict {this.state.companyName} leadership on climate change and other issues.</b></p>
            ) :
            (
              <p><b><ScrollLink to='scores' spy title={this.state.companyName + ' retirement plan sustainability scorecard'} smooth offset={-50} duration={500}><span styleName='scroll-link'>The scorecard results for {this.state.companyName} retirement plan</span></ScrollLink> directly contradict {this.state.companyName} leadership on climate change and other issues.</b></p>
            )
        }

        <p>Since 1992, <i>As You Sow</i> has had great success helping companies to adopt beneficial policies and practices on a range of environmental, social, and governance issues. The time is ripe for {this.state.companyName} to show its leadership by aligning its sustainability goals holistically across both operations and its retirement plan. We commend {this.state.companyName} in its efforts to build a sustainable business for all stakeholders and the planet, including ambitious climate goals and implementing them with action.</p>

        <p>While {this.state.companyName} has made significant efforts in addressing climate change and social issues across its operations, data obtained from Form 5500 SEC filings, along with information published by the Company for retirement plan participants, demonstrates a lack of alignment between the Company’s sustainability goals and its current retirement investment options offered through the Company’s employee retirement plan. Although {this.state.companyName} has established its commitment to reducing its climate impact, {this.state.ESGOptions}</p>

        <p>Critically, the default plan option is not invested sustainably. {this.state.defaultPercent} invested in the {this.state.companyName} employee retirement plan are invested in the default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.</p>

        <p>Most employees assume the default option in their retirement plan is a safe choice. But if climate risk and other sustainability issues are not incorporated into the portfolio composition by the fund manager, employees could be exposed to financial risks from unsustainable investments. Asset managers recognize they have a fiduciary duty to mitigate the systemic risks of climate change: in 2020, <Link to={'https://www.blackrock.com/corporate/investor-relations/2020-blackrock-client-letter'} title='Sustainability as BlackRock’s New Standard for Investing' xstrong>major asset manager BlackRock announced</Link> "We intend to make sustainable funds the standard." </p>

        {
          this.state.differentPage ?
            (
              <p><b>{this.state.companyName}'s retirement plan is rated Poor on five of seven issue areas. The full results <Link to={config.routes.plans + '/' + this.state.companyPath} title={this.state.companyName + ' retirement plan sustainability scorecard'} xstrong>can be found here.</Link></b></p>
            ) :
            (
              <p><b>{this.state.companyName}'s retirement plan is rated Poor on five of seven issue areas. The full results <ScrollLink to='scores' spy title={this.state.companyName + ' retirement plan sustainability scorecard'} smooth offset={-50} duration={500}><span styleName='scroll-link'>can be found here.</span></ScrollLink></b></p>
            )
        }

        <p>{this.state.companyName} has the unique opportunity to become an industry leader and help shift billions of dollars away from climate destruction and into companies that define the new economic paradigm in a safe, just, and sustainable world. We would appreciate the opportunity to meet with you and show you the details of our scorecard.</p>

        <p>Thank you for your time and consideration, and we look forward to hearing back from you. </p>

        <AndrewBeharSignature />

      </blockquote>
    )
  }
}
